// This file is auto-generated by @hey-api/openapi-ts

import {
  type Options,
  createUserPlanPlanCreateLessonIdGet,
  validateUserPlanPlanValidatePost,
  updateUserPlanSectionPlanSubmitSectionPost,
  getUserPlanPlanAllUserPlansGet,
  updateUserPlanPlanUpdatePost,
  getGradesListGradePost,
  getSubjectsListGradeSubjectPost,
  getLessonListLessonLessonIdGet,
  getLessonsListGradeSubjectLessonsPost,
  getGuidanceListGuidancePost,
  signinAuthSigninPost,
  forgotPasswordAuthForgotPasswordPost,
  changePasswordAuthChangePasswordPost,
  newUserChangePasswordAuthNewUserChangePasswordPost,
  newAccessTokenAuthNewTokenPost,
  logoutAuthLogoutPost,
  createLessonSetupLessonPost,
  createInitialLessonPlanSetupLessonPlanPost,
  createGuidanceSetupGuidancePost,
  deleteUserLessonPlanDeleteUserLessonPlanPost,
  deleteLessonDeleteLessonPost,
  deleteGuidanceDeleteGuidancePost,
  deleteAllGuidanceDeleteAllGuidancePost,
  askQuestionChatbotAskPost,
  rootGet,
  healthHealthGet,
  helloWorldHelloWorldGet,
} from '../sdk.gen'
import {
  queryOptions,
  type UseMutationOptions,
  type DefaultError,
} from '@tanstack/react-query'
import type {
  CreateUserPlanPlanCreateLessonIdGetData,
  ValidateUserPlanPlanValidatePostData,
  ValidateUserPlanPlanValidatePostError,
  ValidateUserPlanPlanValidatePostResponse,
  UpdateUserPlanSectionPlanSubmitSectionPostData,
  UpdateUserPlanSectionPlanSubmitSectionPostError,
  UpdateUserPlanSectionPlanSubmitSectionPostResponse,
  GetUserPlanPlanAllUserPlansGetData,
  UpdateUserPlanPlanUpdatePostData,
  UpdateUserPlanPlanUpdatePostError,
  UpdateUserPlanPlanUpdatePostResponse,
  GetGradesListGradePostData,
  GetGradesListGradePostResponse,
  GetSubjectsListGradeSubjectPostData,
  GetSubjectsListGradeSubjectPostError,
  GetSubjectsListGradeSubjectPostResponse,
  GetLessonListLessonLessonIdGetData,
  GetLessonsListGradeSubjectLessonsPostData,
  GetLessonsListGradeSubjectLessonsPostError,
  GetLessonsListGradeSubjectLessonsPostResponse,
  GetGuidanceListGuidancePostData,
  GetGuidanceListGuidancePostResponse,
  SigninAuthSigninPostData,
  SigninAuthSigninPostError,
  SigninAuthSigninPostResponse,
  ForgotPasswordAuthForgotPasswordPostData,
  ForgotPasswordAuthForgotPasswordPostError,
  ChangePasswordAuthChangePasswordPostData,
  ChangePasswordAuthChangePasswordPostError,
  NewUserChangePasswordAuthNewUserChangePasswordPostData,
  NewUserChangePasswordAuthNewUserChangePasswordPostError,
  NewUserChangePasswordAuthNewUserChangePasswordPostResponse,
  NewAccessTokenAuthNewTokenPostData,
  NewAccessTokenAuthNewTokenPostError,
  NewAccessTokenAuthNewTokenPostResponse,
  LogoutAuthLogoutPostData,
  CreateLessonSetupLessonPostData,
  CreateLessonSetupLessonPostError,
  CreateLessonSetupLessonPostResponse,
  CreateInitialLessonPlanSetupLessonPlanPostData,
  CreateInitialLessonPlanSetupLessonPlanPostError,
  CreateInitialLessonPlanSetupLessonPlanPostResponse,
  CreateGuidanceSetupGuidancePostData,
  CreateGuidanceSetupGuidancePostError,
  CreateGuidanceSetupGuidancePostResponse,
  DeleteUserLessonPlanDeleteUserLessonPlanPostData,
  DeleteUserLessonPlanDeleteUserLessonPlanPostError,
  DeleteUserLessonPlanDeleteUserLessonPlanPostResponse,
  DeleteLessonDeleteLessonPostData,
  DeleteLessonDeleteLessonPostError,
  DeleteLessonDeleteLessonPostResponse,
  DeleteGuidanceDeleteGuidancePostData,
  DeleteGuidanceDeleteGuidancePostError,
  DeleteGuidanceDeleteGuidancePostResponse,
  DeleteAllGuidanceDeleteAllGuidancePostData,
  DeleteAllGuidanceDeleteAllGuidancePostResponse,
  AskQuestionChatbotAskPostData,
  AskQuestionChatbotAskPostError,
  AskQuestionChatbotAskPostResponse,
  RootGetData,
  HealthHealthGetData,
  HelloWorldHelloWorldGetData,
} from '../types.gen'
import { client as _heyApiClient } from '../client.gen'

export type QueryKey<TOptions extends Options> = [
  Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
    _id: string
    _infinite?: boolean
    tags?: ReadonlyArray<string>
  },
]

const createQueryKey = <TOptions extends Options>(
  id: string,
  options?: TOptions,
  infinite?: boolean,
  tags?: ReadonlyArray<string>,
): [QueryKey<TOptions>[0]] => {
  const params: QueryKey<TOptions>[0] = {
    _id: id,
    baseUrl:
      options?.baseUrl ||
      (options?.client ?? _heyApiClient).getConfig().baseUrl,
  } as QueryKey<TOptions>[0]
  if (infinite) {
    params._infinite = infinite
  }
  if (tags) {
    params.tags = tags
  }
  if (options?.body) {
    params.body = options.body
  }
  if (options?.headers) {
    params.headers = options.headers
  }
  if (options?.path) {
    params.path = options.path
  }
  if (options?.query) {
    params.query = options.query
  }
  return [params]
}

export const createUserPlanPlanCreateLessonIdGetQueryKey = (
  options: Options<CreateUserPlanPlanCreateLessonIdGetData>,
) => createQueryKey('createUserPlanPlanCreateLessonIdGet', options)

/**
 * Create User Plan
 */
export const createUserPlanPlanCreateLessonIdGetOptions = (
  options: Options<CreateUserPlanPlanCreateLessonIdGetData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await createUserPlanPlanCreateLessonIdGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: createUserPlanPlanCreateLessonIdGetQueryKey(options),
  })
}

export const validateUserPlanPlanValidatePostQueryKey = (
  options: Options<ValidateUserPlanPlanValidatePostData>,
) => createQueryKey('validateUserPlanPlanValidatePost', options)

/**
 * Validate User Plan
 */
export const validateUserPlanPlanValidatePostOptions = (
  options: Options<ValidateUserPlanPlanValidatePostData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await validateUserPlanPlanValidatePost({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: validateUserPlanPlanValidatePostQueryKey(options),
  })
}

/**
 * Validate User Plan
 */
export const validateUserPlanPlanValidatePostMutation = (
  options?: Partial<Options<ValidateUserPlanPlanValidatePostData>>,
): UseMutationOptions<
  ValidateUserPlanPlanValidatePostResponse,
  ValidateUserPlanPlanValidatePostError,
  Options<ValidateUserPlanPlanValidatePostData>
> => {
  const mutationOptions: UseMutationOptions<
    ValidateUserPlanPlanValidatePostResponse,
    ValidateUserPlanPlanValidatePostError,
    Options<ValidateUserPlanPlanValidatePostData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await validateUserPlanPlanValidatePost({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const updateUserPlanSectionPlanSubmitSectionPostQueryKey = (
  options: Options<UpdateUserPlanSectionPlanSubmitSectionPostData>,
) => createQueryKey('updateUserPlanSectionPlanSubmitSectionPost', options)

/**
 * Update User Plan Section
 */
export const updateUserPlanSectionPlanSubmitSectionPostOptions = (
  options: Options<UpdateUserPlanSectionPlanSubmitSectionPostData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await updateUserPlanSectionPlanSubmitSectionPost({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: updateUserPlanSectionPlanSubmitSectionPostQueryKey(options),
  })
}

/**
 * Update User Plan Section
 */
export const updateUserPlanSectionPlanSubmitSectionPostMutation = (
  options?: Partial<Options<UpdateUserPlanSectionPlanSubmitSectionPostData>>,
): UseMutationOptions<
  UpdateUserPlanSectionPlanSubmitSectionPostResponse,
  UpdateUserPlanSectionPlanSubmitSectionPostError,
  Options<UpdateUserPlanSectionPlanSubmitSectionPostData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateUserPlanSectionPlanSubmitSectionPostResponse,
    UpdateUserPlanSectionPlanSubmitSectionPostError,
    Options<UpdateUserPlanSectionPlanSubmitSectionPostData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await updateUserPlanSectionPlanSubmitSectionPost({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getUserPlanPlanAllUserPlansGetQueryKey = (
  options?: Options<GetUserPlanPlanAllUserPlansGetData>,
) => createQueryKey('getUserPlanPlanAllUserPlansGet', options)

/**
 * Get User Plan
 */
export const getUserPlanPlanAllUserPlansGetOptions = (
  options?: Options<GetUserPlanPlanAllUserPlansGetData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getUserPlanPlanAllUserPlansGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getUserPlanPlanAllUserPlansGetQueryKey(options),
  })
}

export const updateUserPlanPlanUpdatePostQueryKey = (
  options: Options<UpdateUserPlanPlanUpdatePostData>,
) => createQueryKey('updateUserPlanPlanUpdatePost', options)

/**
 * Update User Plan
 */
export const updateUserPlanPlanUpdatePostOptions = (
  options: Options<UpdateUserPlanPlanUpdatePostData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await updateUserPlanPlanUpdatePost({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: updateUserPlanPlanUpdatePostQueryKey(options),
  })
}

/**
 * Update User Plan
 */
export const updateUserPlanPlanUpdatePostMutation = (
  options?: Partial<Options<UpdateUserPlanPlanUpdatePostData>>,
): UseMutationOptions<
  UpdateUserPlanPlanUpdatePostResponse,
  UpdateUserPlanPlanUpdatePostError,
  Options<UpdateUserPlanPlanUpdatePostData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateUserPlanPlanUpdatePostResponse,
    UpdateUserPlanPlanUpdatePostError,
    Options<UpdateUserPlanPlanUpdatePostData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await updateUserPlanPlanUpdatePost({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getGradesListGradePostQueryKey = (
  options?: Options<GetGradesListGradePostData>,
) => createQueryKey('getGradesListGradePost', options)

/**
 * Get Grades
 */
export const getGradesListGradePostOptions = (
  options?: Options<GetGradesListGradePostData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getGradesListGradePost({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getGradesListGradePostQueryKey(options),
  })
}

/**
 * Get Grades
 */
export const getGradesListGradePostMutation = (
  options?: Partial<Options<GetGradesListGradePostData>>,
): UseMutationOptions<
  GetGradesListGradePostResponse,
  DefaultError,
  Options<GetGradesListGradePostData>
> => {
  const mutationOptions: UseMutationOptions<
    GetGradesListGradePostResponse,
    DefaultError,
    Options<GetGradesListGradePostData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await getGradesListGradePost({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getSubjectsListGradeSubjectPostQueryKey = (
  options: Options<GetSubjectsListGradeSubjectPostData>,
) => createQueryKey('getSubjectsListGradeSubjectPost', options)

/**
 * Get Subjects
 */
export const getSubjectsListGradeSubjectPostOptions = (
  options: Options<GetSubjectsListGradeSubjectPostData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getSubjectsListGradeSubjectPost({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getSubjectsListGradeSubjectPostQueryKey(options),
  })
}

/**
 * Get Subjects
 */
export const getSubjectsListGradeSubjectPostMutation = (
  options?: Partial<Options<GetSubjectsListGradeSubjectPostData>>,
): UseMutationOptions<
  GetSubjectsListGradeSubjectPostResponse,
  GetSubjectsListGradeSubjectPostError,
  Options<GetSubjectsListGradeSubjectPostData>
> => {
  const mutationOptions: UseMutationOptions<
    GetSubjectsListGradeSubjectPostResponse,
    GetSubjectsListGradeSubjectPostError,
    Options<GetSubjectsListGradeSubjectPostData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await getSubjectsListGradeSubjectPost({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getLessonListLessonLessonIdGetQueryKey = (
  options: Options<GetLessonListLessonLessonIdGetData>,
) => createQueryKey('getLessonListLessonLessonIdGet', options)

/**
 * Get Lesson
 */
export const getLessonListLessonLessonIdGetOptions = (
  options: Options<GetLessonListLessonLessonIdGetData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getLessonListLessonLessonIdGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getLessonListLessonLessonIdGetQueryKey(options),
  })
}

export const getLessonsListGradeSubjectLessonsPostQueryKey = (
  options: Options<GetLessonsListGradeSubjectLessonsPostData>,
) => createQueryKey('getLessonsListGradeSubjectLessonsPost', options)

/**
 * Get Lessons
 */
export const getLessonsListGradeSubjectLessonsPostOptions = (
  options: Options<GetLessonsListGradeSubjectLessonsPostData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getLessonsListGradeSubjectLessonsPost({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getLessonsListGradeSubjectLessonsPostQueryKey(options),
  })
}

/**
 * Get Lessons
 */
export const getLessonsListGradeSubjectLessonsPostMutation = (
  options?: Partial<Options<GetLessonsListGradeSubjectLessonsPostData>>,
): UseMutationOptions<
  GetLessonsListGradeSubjectLessonsPostResponse,
  GetLessonsListGradeSubjectLessonsPostError,
  Options<GetLessonsListGradeSubjectLessonsPostData>
> => {
  const mutationOptions: UseMutationOptions<
    GetLessonsListGradeSubjectLessonsPostResponse,
    GetLessonsListGradeSubjectLessonsPostError,
    Options<GetLessonsListGradeSubjectLessonsPostData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await getLessonsListGradeSubjectLessonsPost({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getGuidanceListGuidancePostQueryKey = (
  options?: Options<GetGuidanceListGuidancePostData>,
) => createQueryKey('getGuidanceListGuidancePost', options)

/**
 * Get Guidance
 */
export const getGuidanceListGuidancePostOptions = (
  options?: Options<GetGuidanceListGuidancePostData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getGuidanceListGuidancePost({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getGuidanceListGuidancePostQueryKey(options),
  })
}

/**
 * Get Guidance
 */
export const getGuidanceListGuidancePostMutation = (
  options?: Partial<Options<GetGuidanceListGuidancePostData>>,
): UseMutationOptions<
  GetGuidanceListGuidancePostResponse,
  DefaultError,
  Options<GetGuidanceListGuidancePostData>
> => {
  const mutationOptions: UseMutationOptions<
    GetGuidanceListGuidancePostResponse,
    DefaultError,
    Options<GetGuidanceListGuidancePostData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await getGuidanceListGuidancePost({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const signinAuthSigninPostQueryKey = (
  options: Options<SigninAuthSigninPostData>,
) => createQueryKey('signinAuthSigninPost', options)

/**
 * Signin
 */
export const signinAuthSigninPostOptions = (
  options: Options<SigninAuthSigninPostData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await signinAuthSigninPost({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: signinAuthSigninPostQueryKey(options),
  })
}

/**
 * Signin
 */
export const signinAuthSigninPostMutation = (
  options?: Partial<Options<SigninAuthSigninPostData>>,
): UseMutationOptions<
  SigninAuthSigninPostResponse,
  SigninAuthSigninPostError,
  Options<SigninAuthSigninPostData>
> => {
  const mutationOptions: UseMutationOptions<
    SigninAuthSigninPostResponse,
    SigninAuthSigninPostError,
    Options<SigninAuthSigninPostData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await signinAuthSigninPost({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const forgotPasswordAuthForgotPasswordPostQueryKey = (
  options: Options<ForgotPasswordAuthForgotPasswordPostData>,
) => createQueryKey('forgotPasswordAuthForgotPasswordPost', options)

/**
 * Forgot Password
 */
export const forgotPasswordAuthForgotPasswordPostOptions = (
  options: Options<ForgotPasswordAuthForgotPasswordPostData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await forgotPasswordAuthForgotPasswordPost({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: forgotPasswordAuthForgotPasswordPostQueryKey(options),
  })
}

/**
 * Forgot Password
 */
export const forgotPasswordAuthForgotPasswordPostMutation = (
  options?: Partial<Options<ForgotPasswordAuthForgotPasswordPostData>>,
): UseMutationOptions<
  unknown,
  ForgotPasswordAuthForgotPasswordPostError,
  Options<ForgotPasswordAuthForgotPasswordPostData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    ForgotPasswordAuthForgotPasswordPostError,
    Options<ForgotPasswordAuthForgotPasswordPostData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await forgotPasswordAuthForgotPasswordPost({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const changePasswordAuthChangePasswordPostQueryKey = (
  options: Options<ChangePasswordAuthChangePasswordPostData>,
) => createQueryKey('changePasswordAuthChangePasswordPost', options)

/**
 * Change Password
 */
export const changePasswordAuthChangePasswordPostOptions = (
  options: Options<ChangePasswordAuthChangePasswordPostData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await changePasswordAuthChangePasswordPost({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: changePasswordAuthChangePasswordPostQueryKey(options),
  })
}

/**
 * Change Password
 */
export const changePasswordAuthChangePasswordPostMutation = (
  options?: Partial<Options<ChangePasswordAuthChangePasswordPostData>>,
): UseMutationOptions<
  unknown,
  ChangePasswordAuthChangePasswordPostError,
  Options<ChangePasswordAuthChangePasswordPostData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    ChangePasswordAuthChangePasswordPostError,
    Options<ChangePasswordAuthChangePasswordPostData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await changePasswordAuthChangePasswordPost({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const newUserChangePasswordAuthNewUserChangePasswordPostQueryKey = (
  options: Options<NewUserChangePasswordAuthNewUserChangePasswordPostData>,
) =>
  createQueryKey('newUserChangePasswordAuthNewUserChangePasswordPost', options)

/**
 * New User Change Password
 */
export const newUserChangePasswordAuthNewUserChangePasswordPostOptions = (
  options: Options<NewUserChangePasswordAuthNewUserChangePasswordPostData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await newUserChangePasswordAuthNewUserChangePasswordPost(
        {
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true,
        },
      )
      return data
    },
    queryKey:
      newUserChangePasswordAuthNewUserChangePasswordPostQueryKey(options),
  })
}

/**
 * New User Change Password
 */
export const newUserChangePasswordAuthNewUserChangePasswordPostMutation = (
  options?: Partial<
    Options<NewUserChangePasswordAuthNewUserChangePasswordPostData>
  >,
): UseMutationOptions<
  NewUserChangePasswordAuthNewUserChangePasswordPostResponse,
  NewUserChangePasswordAuthNewUserChangePasswordPostError,
  Options<NewUserChangePasswordAuthNewUserChangePasswordPostData>
> => {
  const mutationOptions: UseMutationOptions<
    NewUserChangePasswordAuthNewUserChangePasswordPostResponse,
    NewUserChangePasswordAuthNewUserChangePasswordPostError,
    Options<NewUserChangePasswordAuthNewUserChangePasswordPostData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await newUserChangePasswordAuthNewUserChangePasswordPost(
        {
          ...options,
          ...localOptions,
          throwOnError: true,
        },
      )
      return data
    },
  }
  return mutationOptions
}

export const newAccessTokenAuthNewTokenPostQueryKey = (
  options: Options<NewAccessTokenAuthNewTokenPostData>,
) => createQueryKey('newAccessTokenAuthNewTokenPost', options)

/**
 * New Access Token
 */
export const newAccessTokenAuthNewTokenPostOptions = (
  options: Options<NewAccessTokenAuthNewTokenPostData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await newAccessTokenAuthNewTokenPost({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: newAccessTokenAuthNewTokenPostQueryKey(options),
  })
}

/**
 * New Access Token
 */
export const newAccessTokenAuthNewTokenPostMutation = (
  options?: Partial<Options<NewAccessTokenAuthNewTokenPostData>>,
): UseMutationOptions<
  NewAccessTokenAuthNewTokenPostResponse,
  NewAccessTokenAuthNewTokenPostError,
  Options<NewAccessTokenAuthNewTokenPostData>
> => {
  const mutationOptions: UseMutationOptions<
    NewAccessTokenAuthNewTokenPostResponse,
    NewAccessTokenAuthNewTokenPostError,
    Options<NewAccessTokenAuthNewTokenPostData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await newAccessTokenAuthNewTokenPost({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const logoutAuthLogoutPostQueryKey = (
  options?: Options<LogoutAuthLogoutPostData>,
) => createQueryKey('logoutAuthLogoutPost', options)

/**
 * Logout
 */
export const logoutAuthLogoutPostOptions = (
  options?: Options<LogoutAuthLogoutPostData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await logoutAuthLogoutPost({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: logoutAuthLogoutPostQueryKey(options),
  })
}

/**
 * Logout
 */
export const logoutAuthLogoutPostMutation = (
  options?: Partial<Options<LogoutAuthLogoutPostData>>,
): UseMutationOptions<
  unknown,
  DefaultError,
  Options<LogoutAuthLogoutPostData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    DefaultError,
    Options<LogoutAuthLogoutPostData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await logoutAuthLogoutPost({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const createLessonSetupLessonPostQueryKey = (
  options: Options<CreateLessonSetupLessonPostData>,
) => createQueryKey('createLessonSetupLessonPost', options)

/**
 * Create Lesson
 */
export const createLessonSetupLessonPostOptions = (
  options: Options<CreateLessonSetupLessonPostData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await createLessonSetupLessonPost({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: createLessonSetupLessonPostQueryKey(options),
  })
}

/**
 * Create Lesson
 */
export const createLessonSetupLessonPostMutation = (
  options?: Partial<Options<CreateLessonSetupLessonPostData>>,
): UseMutationOptions<
  CreateLessonSetupLessonPostResponse,
  CreateLessonSetupLessonPostError,
  Options<CreateLessonSetupLessonPostData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateLessonSetupLessonPostResponse,
    CreateLessonSetupLessonPostError,
    Options<CreateLessonSetupLessonPostData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await createLessonSetupLessonPost({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const createInitialLessonPlanSetupLessonPlanPostQueryKey = (
  options: Options<CreateInitialLessonPlanSetupLessonPlanPostData>,
) => createQueryKey('createInitialLessonPlanSetupLessonPlanPost', options)

/**
 * Create Initial Lesson Plan
 */
export const createInitialLessonPlanSetupLessonPlanPostOptions = (
  options: Options<CreateInitialLessonPlanSetupLessonPlanPostData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await createInitialLessonPlanSetupLessonPlanPost({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: createInitialLessonPlanSetupLessonPlanPostQueryKey(options),
  })
}

/**
 * Create Initial Lesson Plan
 */
export const createInitialLessonPlanSetupLessonPlanPostMutation = (
  options?: Partial<Options<CreateInitialLessonPlanSetupLessonPlanPostData>>,
): UseMutationOptions<
  CreateInitialLessonPlanSetupLessonPlanPostResponse,
  CreateInitialLessonPlanSetupLessonPlanPostError,
  Options<CreateInitialLessonPlanSetupLessonPlanPostData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateInitialLessonPlanSetupLessonPlanPostResponse,
    CreateInitialLessonPlanSetupLessonPlanPostError,
    Options<CreateInitialLessonPlanSetupLessonPlanPostData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await createInitialLessonPlanSetupLessonPlanPost({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const createGuidanceSetupGuidancePostQueryKey = (
  options: Options<CreateGuidanceSetupGuidancePostData>,
) => createQueryKey('createGuidanceSetupGuidancePost', options)

/**
 * Create Guidance
 */
export const createGuidanceSetupGuidancePostOptions = (
  options: Options<CreateGuidanceSetupGuidancePostData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await createGuidanceSetupGuidancePost({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: createGuidanceSetupGuidancePostQueryKey(options),
  })
}

/**
 * Create Guidance
 */
export const createGuidanceSetupGuidancePostMutation = (
  options?: Partial<Options<CreateGuidanceSetupGuidancePostData>>,
): UseMutationOptions<
  CreateGuidanceSetupGuidancePostResponse,
  CreateGuidanceSetupGuidancePostError,
  Options<CreateGuidanceSetupGuidancePostData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateGuidanceSetupGuidancePostResponse,
    CreateGuidanceSetupGuidancePostError,
    Options<CreateGuidanceSetupGuidancePostData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await createGuidanceSetupGuidancePost({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const deleteUserLessonPlanDeleteUserLessonPlanPostQueryKey = (
  options: Options<DeleteUserLessonPlanDeleteUserLessonPlanPostData>,
) => createQueryKey('deleteUserLessonPlanDeleteUserLessonPlanPost', options)

/**
 * Delete User Lesson Plan
 */
export const deleteUserLessonPlanDeleteUserLessonPlanPostOptions = (
  options: Options<DeleteUserLessonPlanDeleteUserLessonPlanPostData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await deleteUserLessonPlanDeleteUserLessonPlanPost({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: deleteUserLessonPlanDeleteUserLessonPlanPostQueryKey(options),
  })
}

/**
 * Delete User Lesson Plan
 */
export const deleteUserLessonPlanDeleteUserLessonPlanPostMutation = (
  options?: Partial<Options<DeleteUserLessonPlanDeleteUserLessonPlanPostData>>,
): UseMutationOptions<
  DeleteUserLessonPlanDeleteUserLessonPlanPostResponse,
  DeleteUserLessonPlanDeleteUserLessonPlanPostError,
  Options<DeleteUserLessonPlanDeleteUserLessonPlanPostData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteUserLessonPlanDeleteUserLessonPlanPostResponse,
    DeleteUserLessonPlanDeleteUserLessonPlanPostError,
    Options<DeleteUserLessonPlanDeleteUserLessonPlanPostData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await deleteUserLessonPlanDeleteUserLessonPlanPost({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const deleteLessonDeleteLessonPostQueryKey = (
  options: Options<DeleteLessonDeleteLessonPostData>,
) => createQueryKey('deleteLessonDeleteLessonPost', options)

/**
 * Delete Lesson
 */
export const deleteLessonDeleteLessonPostOptions = (
  options: Options<DeleteLessonDeleteLessonPostData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await deleteLessonDeleteLessonPost({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: deleteLessonDeleteLessonPostQueryKey(options),
  })
}

/**
 * Delete Lesson
 */
export const deleteLessonDeleteLessonPostMutation = (
  options?: Partial<Options<DeleteLessonDeleteLessonPostData>>,
): UseMutationOptions<
  DeleteLessonDeleteLessonPostResponse,
  DeleteLessonDeleteLessonPostError,
  Options<DeleteLessonDeleteLessonPostData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteLessonDeleteLessonPostResponse,
    DeleteLessonDeleteLessonPostError,
    Options<DeleteLessonDeleteLessonPostData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await deleteLessonDeleteLessonPost({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const deleteGuidanceDeleteGuidancePostQueryKey = (
  options: Options<DeleteGuidanceDeleteGuidancePostData>,
) => createQueryKey('deleteGuidanceDeleteGuidancePost', options)

/**
 * Delete Guidance
 */
export const deleteGuidanceDeleteGuidancePostOptions = (
  options: Options<DeleteGuidanceDeleteGuidancePostData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await deleteGuidanceDeleteGuidancePost({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: deleteGuidanceDeleteGuidancePostQueryKey(options),
  })
}

/**
 * Delete Guidance
 */
export const deleteGuidanceDeleteGuidancePostMutation = (
  options?: Partial<Options<DeleteGuidanceDeleteGuidancePostData>>,
): UseMutationOptions<
  DeleteGuidanceDeleteGuidancePostResponse,
  DeleteGuidanceDeleteGuidancePostError,
  Options<DeleteGuidanceDeleteGuidancePostData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteGuidanceDeleteGuidancePostResponse,
    DeleteGuidanceDeleteGuidancePostError,
    Options<DeleteGuidanceDeleteGuidancePostData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await deleteGuidanceDeleteGuidancePost({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const deleteAllGuidanceDeleteAllGuidancePostQueryKey = (
  options?: Options<DeleteAllGuidanceDeleteAllGuidancePostData>,
) => createQueryKey('deleteAllGuidanceDeleteAllGuidancePost', options)

/**
 * Delete All Guidance
 */
export const deleteAllGuidanceDeleteAllGuidancePostOptions = (
  options?: Options<DeleteAllGuidanceDeleteAllGuidancePostData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await deleteAllGuidanceDeleteAllGuidancePost({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: deleteAllGuidanceDeleteAllGuidancePostQueryKey(options),
  })
}

/**
 * Delete All Guidance
 */
export const deleteAllGuidanceDeleteAllGuidancePostMutation = (
  options?: Partial<Options<DeleteAllGuidanceDeleteAllGuidancePostData>>,
): UseMutationOptions<
  DeleteAllGuidanceDeleteAllGuidancePostResponse,
  DefaultError,
  Options<DeleteAllGuidanceDeleteAllGuidancePostData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteAllGuidanceDeleteAllGuidancePostResponse,
    DefaultError,
    Options<DeleteAllGuidanceDeleteAllGuidancePostData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await deleteAllGuidanceDeleteAllGuidancePost({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const askQuestionChatbotAskPostQueryKey = (
  options: Options<AskQuestionChatbotAskPostData>,
) => createQueryKey('askQuestionChatbotAskPost', options)

/**
 * Ask Question
 * Ask a question to the chatbot.
 * If the user is on the mind map tab of the web application for a specific lesson, the chatbot will have access to the slide descriptions of the section that the user is currently looking at on their screen.
 * It will also have access to the user's lesson plan (mind map) if provided.
 */
export const askQuestionChatbotAskPostOptions = (
  options: Options<AskQuestionChatbotAskPostData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await askQuestionChatbotAskPost({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: askQuestionChatbotAskPostQueryKey(options),
  })
}

/**
 * Ask Question
 * Ask a question to the chatbot.
 * If the user is on the mind map tab of the web application for a specific lesson, the chatbot will have access to the slide descriptions of the section that the user is currently looking at on their screen.
 * It will also have access to the user's lesson plan (mind map) if provided.
 */
export const askQuestionChatbotAskPostMutation = (
  options?: Partial<Options<AskQuestionChatbotAskPostData>>,
): UseMutationOptions<
  AskQuestionChatbotAskPostResponse,
  AskQuestionChatbotAskPostError,
  Options<AskQuestionChatbotAskPostData>
> => {
  const mutationOptions: UseMutationOptions<
    AskQuestionChatbotAskPostResponse,
    AskQuestionChatbotAskPostError,
    Options<AskQuestionChatbotAskPostData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await askQuestionChatbotAskPost({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const rootGetQueryKey = (options?: Options<RootGetData>) =>
  createQueryKey('rootGet', options)

/**
 * Root
 */
export const rootGetOptions = (options?: Options<RootGetData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await rootGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: rootGetQueryKey(options),
  })
}

export const healthHealthGetQueryKey = (
  options?: Options<HealthHealthGetData>,
) => createQueryKey('healthHealthGet', options)

/**
 * Health
 */
export const healthHealthGetOptions = (
  options?: Options<HealthHealthGetData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await healthHealthGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: healthHealthGetQueryKey(options),
  })
}

export const helloWorldHelloWorldGetQueryKey = (
  options?: Options<HelloWorldHelloWorldGetData>,
) => createQueryKey('helloWorldHelloWorldGet', options)

/**
 * Hello World
 */
export const helloWorldHelloWorldGetOptions = (
  options?: Options<HelloWorldHelloWorldGetData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await helloWorldHelloWorldGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: helloWorldHelloWorldGetQueryKey(options),
  })
}
